"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _contextMenuBlocker = _interopRequireDefault(require("./context-menu-blocker.effect"));

const ContextMenuBlocker = ({
  element
}) => {
  (0, _contextMenuBlocker.default)(element);
  return null;
};

ContextMenuBlocker.propTypes = {
  element: _propTypes.default.instanceOf(global.Element)
};
ContextMenuBlocker.defaultProps = {
  element: null
};
var _default = ContextMenuBlocker;
exports.default = _default;